import { jsx as e, jsxs as n, Fragment as j } from "react/jsx-runtime";
import { createContext as ur, useContext as hr, useCallback as fr, useState as h, useRef as I, useEffect as M, useLayoutEffect as pr } from "react";
import { useQuery as le, useQueryClient as mr, QueryClient as gr, QueryClientProvider as vr } from "@tanstack/react-query";
import { CancellationAttemptSchema as Je, getCancellationContext as nr, ApiError as V, confirmCancellation as yr, prepareCancellation as br, listPortalOrders as Er, getPortalOrder as wr, getOrderOperationAvailability as Ve, getOrderCommandStatus as He, listSourceOrderAssets as Ge, downloadSourceOrderAsset as Cr, getOrderPolicy as ar, OrderMutationPolicySchema as Nr, setOrderMutationPolicy as Rr, setOrderPolicy as Or } from "@dss/api-client";
import { Button as E, Modal as Dr, Banner as fe, Input as Pr, Card as te } from "@dss/design-system";
function ir(t, a = 0) {
  if (typeof t != "string" || !/^-?\d+(\.\d+)?$(?![\s\S])/.test(t))
    throw new Error("Некорректное десятичное значение");
  const [i = "0", u = ""] = t.split("."), l = i.startsWith("-"), A = (l ? i.slice(1) : i).replace(/^0+(?=\d)/, ""), k = u.replace(/0+$/, ""), w = l && (A !== "0" || k !== "") ? "−" : "", T = A.replace(/\B(?=(\d{3})+(?!\d))/g, " "), s = k.padEnd(a, "0");
  return w + T + (s ? `,${s}` : "");
}
function we(t, a) {
  const i = a === "RUB" ? "₽" : a.trim() ? a : "валюта не указана";
  return `${ir(t, 2)} ${i}`;
}
class Ar extends Error {
}
Ar.prototype.name = "InvalidTokenError";
var Ae = /* @__PURE__ */ ((t) => (t[t.NONE = 0] = "NONE", t[t.ERROR = 1] = "ERROR", t[t.WARN = 2] = "WARN", t[t.INFO = 3] = "INFO", t[t.DEBUG = 4] = "DEBUG", t))(Ae || {});
((t) => {
  function a() {
  }
  t.reset = a;
  function i(l) {
    if (!(0 <= l && l <= 4))
      throw new Error("Invalid log level");
  }
  t.setLevel = i;
  function u(l) {
  }
  t.setLogger = u;
})(Ae || (Ae = {}));
Ae.reset();
function Tr() {
  const t = hr(Sr), a = t == null ? void 0 : t.workspace;
  return fr(() => () => !!(a != null && a.active), [a]);
}
const Sr = ur(null), Fr = ["CLIENT_OWNER", "CLIENT_EMPLOYEE"], _r = [
  "DISTRIBUTOR_OWNER",
  "DISTRIBUTOR_ADMIN",
  "DISTRIBUTOR_MANAGER",
  "DISTRIBUTOR_FIELD_EMPLOYEE"
];
new Set(Fr);
new Set(_r);
const Ye = {
  access_revoked: "Доступ к заказу изменился.",
  permission_revoked: "У вас нет права запрашивать отмену.",
  policy_closed: "Дистрибьютор отключил запросы отмены.",
  adapter_unverified: "Обработка отмены в 1С ещё не подтверждена.",
  dossier_changed: "Условия подключения 1С изменились.",
  source_changed: "Данные заказа в 1С изменились.",
  window_closed: "1С не разрешает отмену в текущем состоянии заказа.",
  source_snapshot_missing: "Подтверждённые данные заказа из 1С ещё не получены.",
  mutation_pending: "Предыдущий запрос изменения или отмены ещё не завершён."
};
class ze extends Error {
  constructor(a) {
    super("existing_attempt"), this.attempt = a;
  }
}
function Ir(t) {
  var a, i;
  return t.localResolution === "LOCAL_NOT_DISPATCHED" ? "Запрос закрыт без передачи в 1С. Это не отмена заказа." : t.outcome === "REJECTED" ? "1С отклонила запрос отмены. Проверьте причину с дистрибьютором." : t.outcome === "CONFLICT" ? "Возник конфликт отмены. Нужна проверка заказа в 1С; автоматического повтора нет." : t.outcome === "APPLIED" ? t.state === "CLOSED" ? "Получены результат отмены и соответствующие данные заказа из 1С." : "1С сообщила об обработке отмены. Ожидаем обновлённые данные заказа." : (a = t.deliveryDiagnostic) != null && a.startsWith("DELIVERY_BLOCKED_OUTCOME_UNKNOWN:") ? "Передача остановлена, результат обработки неизвестен. Повторная отмена сейчас недоступна." : (i = t.deliveryDiagnostic) != null && i.startsWith("NOT_DISPATCHED_BLOCKED:") ? "Запрос ещё не передан в 1С: условия отмены изменились." : "Запрос отмены сохранён. Результат обработки в 1С ещё не получен.";
}
function Lr(t) {
  return /* @__PURE__ */ e(kr, { ...t }, `${t.identity}:${t.orderId}`);
}
function kr({ api: t, token: a, identity: i, orderId: u, onAccessDenied: l, onSourceApplied: A }) {
  var be, re, me, ue;
  const k = Tr(), w = `ds2b.cancellation.v1:${JSON.stringify([t.config.baseUrl, i, u])}`, [T] = h(() => {
    try {
      const d = localStorage.getItem(w);
      return { attempt: d === null ? null : Je.parse(JSON.parse(d)), error: !1 };
    } catch {
      return { attempt: null, error: !0 };
    }
  }), [s, c] = h(T.attempt), [y, X] = h(T.error), [S, K] = h("Локальная запись запроса недоступна или повреждена."), [g, C] = h(null), [P, x] = h(!1), [H, U] = h(""), [b, B] = h(!1), O = I(!0), Y = I(0), Z = I(0), oe = I(a);
  oe.current !== a && (oe.current = a, Y.current += 1), M(() => {
    x(!1), C(null);
  }, [a]), M(() => (O.current = !0, () => {
    O.current = !1, Y.current += 1;
  }), []);
  const o = le({
    queryKey: ["portal-cancellation-context", i, u, Y.current],
    queryFn: ({ signal: d }) => nr(t, a, u, d),
    retry: !1,
    staleTime: 0,
    gcTime: 0,
    refetchInterval: 3e4
  }), Q = !o.isError && !o.isFetching && !o.isPending && !!o.data, ee = I(o);
  ee.current = o;
  const pe = o.error instanceof V && [401, 403, 404].includes(o.error.status), ce = I({ onAccessDenied: l, onSourceApplied: A });
  ce.current = { onAccessDenied: l, onSourceApplied: A }, pr(() => {
    var d, m;
    pe && ((m = (d = ce.current).onAccessDenied) == null || m.call(d));
  }, [pe]);
  const se = I(null);
  M(() => {
    var m, N, F;
    const d = Q ? (m = o.data) == null ? void 0 : m.latest : null;
    (d == null ? void 0 : d.state) === "CLOSED" && d.outcome === "APPLIED" && se.current !== d.mutationId && (se.current = d.mutationId, (F = (N = ce.current).onSourceApplied) == null || F.call(N));
  }, [Q, o.data]);
  const Ce = Q && ((be = o.data) == null ? void 0 : be.availability.allowed) && !s && !y && !P;
  M(() => {
    (o.isError || o.data && (!o.data.availability.allowed || o.data.availability.baseRevision !== (g == null ? void 0 : g.baseRevision))) && C(null);
  }, [o.isError, o.data, g == null ? void 0 : g.baseRevision]);
  function de() {
    const d = k(), m = Y.current, N = ++Z.current;
    return () => O.current && m === Y.current && N === Z.current && d();
  }
  function ne(d) {
    var m;
    return (m = navigator.locks) != null && m.request ? navigator.locks.request(w, { mode: "exclusive" }, d) : Promise.reject(new Error("locks_unavailable"));
  }
  async function ve() {
    var m, N;
    if (!Ce) return;
    const d = de();
    x(!0), U("");
    try {
      const F = await o.refetch();
      if (!d() || F.isError || !((m = F.data) != null && m.availability.allowed) || !F.data.availability.baseRevision) return;
      const f = await br(t, a, u, F.data.availability.baseRevision);
      if (!d() || ee.current.isError || !((N = ee.current.data) != null && N.availability.allowed) || ee.current.data.availability.baseRevision !== f.baseRevision) return;
      if (f.orderId !== u || f.baseRevision !== F.data.availability.baseRevision) throw new Error("scope");
      C(f);
    } catch {
      d() && U("Не удалось подготовить отмену. Проверьте текущие условия и попробуйте снова.");
    } finally {
      d() && x(!1);
    }
  }
  async function ye(d) {
    if (P || !Q || y || !d && !g) return;
    const m = de();
    x(!0), U(""), B(!1);
    let N = d, F = !1;
    try {
      const f = await o.refetch();
      if (!m() || f.isError || !f.data) return;
      if (N)
        await ne(() => {
          if (!m() || localStorage.getItem(w) !== JSON.stringify(N)) throw new Error("storage changed");
        });
      else {
        if (!g || !f.data.availability.allowed || f.data.availability.baseRevision !== g.baseRevision || Date.parse(g.expiresAt) <= Date.now()) {
          C(null), U("Условия или срок подтверждения изменились. Подготовьте запрос заново.");
          return;
        }
        const ae = g;
        if (N = await ne(() => {
          if (!m()) throw new Error("inactive");
          const $ = localStorage.getItem(w);
          if ($ !== null) throw new ze(Je.parse(JSON.parse($)));
          const q = { quoteId: ae.quoteId, idempotencyKey: crypto.randomUUID(), baseRevision: ae.baseRevision };
          if (localStorage.setItem(w, JSON.stringify(q)), localStorage.getItem(w) !== JSON.stringify(q)) throw new Error("storage");
          return q;
        }), !m()) return;
        c(N);
      }
      if (F = !0, !m()) return;
      C(null);
      const R = await yr(t, a, u, N);
      if (!m()) return;
      if (R.quoteId !== N.quoteId || R.baseRevision !== N.baseRevision) throw new Error("receipt mismatch");
      if (await ne(() => {
        m() && localStorage.getItem(w) === JSON.stringify(N) && localStorage.removeItem(w);
      }), !m()) return;
      c(null), U("Запрос отмены сохранён. Это ещё не подтверждение отмены в 1С."), await o.refetch();
    } catch (f) {
      if (!m()) return;
      if (f instanceof ze) {
        c(f.attempt), C(null), U("В другой вкладке уже сохранено подтверждение. Новое не отправлено; можно проверить результат или явно повторить сохранённое.");
        return;
      }
      F ? (U(f instanceof V && f.status === 409 ? "Сервер отклонил подтверждение: условия изменились. Автоматического нового запроса нет." : "Ответ на подтверждение не получен. Не создавайте новый запрос: можно повторить только сохранённое подтверждение."), B(f instanceof V && [400, 409].includes(f.status)), f instanceof V && [401, 403, 404].includes(f.status) && await o.refetch()) : (f instanceof Error && f.message === "locks_unavailable" && K("Браузер не поддерживает безопасное согласование запроса между вкладками."), X(!0), U("Не удалось безопасно сохранить запрос в этом браузере. Отправка остановлена."));
    } finally {
      m() && x(!1);
    }
  }
  async function Ne() {
    if (!b || !s || !Q || P || !k()()) return;
    const d = de();
    try {
      if (await ne(() => {
        if (!d() || localStorage.getItem(w) !== JSON.stringify(s)) throw new Error("changed");
        localStorage.removeItem(w);
      }), !d()) return;
      c(null), B(!1), U(""), o.refetch();
    } catch {
      d() && X(!0);
    }
  }
  return pe ? /* @__PURE__ */ n("section", { "aria-label": "Отмена заказа", children: [
    /* @__PURE__ */ e("p", { role: "alert", children: "Текущий доступ к отмене и её результату не подтверждён. Прежние данные скрыты." }),
    /* @__PURE__ */ e(E, { onClick: () => void o.refetch(), children: "Проверить доступ к отмене" })
  ] }) : /* @__PURE__ */ n("section", { "aria-label": "Отмена заказа", className: "portal-order-cancellation", children: [
    /* @__PURE__ */ e("h2", { children: "Отмена заказа" }),
    o.isError ? /* @__PURE__ */ e("p", { role: "alert", children: "Не удалось проверить отмену. Прежние сведения скрыты." }) : Q ? /* @__PURE__ */ n(j, { children: [
      ((re = o.data) == null ? void 0 : re.latest) && /* @__PURE__ */ n(j, { children: [
        /* @__PURE__ */ e("p", { role: "status", children: Ir(o.data.latest) }),
        o.data.latest.localReason && /* @__PURE__ */ e("p", { children: Ye[o.data.latest.localReason.toLowerCase()] ?? "Нужна проверка условий отмены." }),
        o.data.latest.errorCode && /* @__PURE__ */ n("details", { children: [
          /* @__PURE__ */ e("summary", { children: "Причина ответа 1С" }),
          /* @__PURE__ */ e("p", { children: o.data.latest.errorCode })
        ] })
      ] }),
      !((me = o.data) != null && me.availability.allowed) && /* @__PURE__ */ e("ul", { children: (ue = o.data) == null ? void 0 : ue.availability.reasons.map((d) => /* @__PURE__ */ e("li", { children: Ye[d] }, d)) })
    ] }) : /* @__PURE__ */ e("p", { role: "status", children: "Проверяем текущие условия отмены…" }),
    Q && s && /* @__PURE__ */ n(j, { children: [
      /* @__PURE__ */ e("p", { children: "В браузере сохранено подтверждение с ещё не установленным результатом." }),
      /* @__PURE__ */ e(E, { disabled: P || y, onClick: () => void ye(s), children: "Повторить сохранённое подтверждение" }),
      b && /* @__PURE__ */ e(E, { disabled: P, onClick: () => void Ne(), children: "Проверить условия для нового запроса" })
    ] }),
    y && /* @__PURE__ */ n("p", { role: "alert", children: [
      S,
      " Новая отправка заблокирована; проверьте результат с дистрибьютором."
    ] }),
    H && Q && /* @__PURE__ */ e("p", { role: "alert", children: H }),
    Ce && /* @__PURE__ */ e(E, { onClick: () => void ve(), children: "Запросить отмену" }),
    /* @__PURE__ */ e(E, { disabled: P || o.isFetching, onClick: () => void o.refetch(), children: "Обновить состояние отмены" }),
    /* @__PURE__ */ n(Dr, { open: !!g && Q, onClose: () => {
      P || C(null);
    }, title: "Подтвердить запрос отмены", footer: /* @__PURE__ */ n(j, { children: [
      /* @__PURE__ */ e(E, { disabled: P, onClick: () => C(null), children: "Вернуться к заказу" }),
      /* @__PURE__ */ e(E, { disabled: P || !Q, onClick: () => void ye(), children: "Отправить запрос отмены" })
    ] }), children: [
      /* @__PURE__ */ e("p", { children: "Заказ пока не отменён. Запрос будет передан в 1С; дождитесь результата и обновлённых данных заказа." }),
      /* @__PURE__ */ e("p", { children: "Состав, суммы и доставка этим запросом не изменяются." })
    ] })
  ] });
}
const Pe = ["portal-order-list-context"];
function qr(t) {
  switch (t) {
    case "PENDING":
      return "Ожидает запроса 1С.";
    case "IN_FLIGHT":
      return "Команда выдана для обработки; результат ожидается.";
    case "WAITING":
      return "Обработка отложена; ожидается следующий запрос 1С.";
    case "RETRY":
      return "Ожидает повторной выдачи по запросу 1С.";
    case "DEAD_LETTER":
      return "Выдача остановлена; нужна проверка обмена.";
    case "APPLIED":
      return "Выдача завершена со статусом применения; подтверждение проверяется отдельно.";
    case "REJECTED":
      return "Выдача завершена со статусом отказа; подтверждение проверяется отдельно.";
    case "CONFLICT":
      return "Выдача завершена со статусом конфликта; подтверждение проверяется отдельно.";
    default:
      return "Состояние очереди не распознано. Проверьте данные повторно.";
  }
}
const xr = {
  permission_missing: "у вас нет права на эту операцию",
  policy_disabled: "операция отключена в настройках дистрибьютора",
  source_snapshot_missing: "подтверждённые данные заказа из 1С ещё не получены",
  mutation_pending: "предыдущий запрос изменения или отмены ещё не завершён",
  source_window_unverified: "правила обработки в 1С ещё не подтверждены",
  operation_adapter_not_verified: "поддержка операции при обмене с 1С ещё не подтверждена"
};
function Gr(t) {
  return /* @__PURE__ */ e(Ur, { ...t }, `${t.identity}:${t.orderId ?? "list"}`);
}
function Ur({ api: t, token: a, identity: i, viewerRole: u, orderId: l, onOpen: A, onBack: k }) {
  var ke, qe, xe, Ue, Be, $e, Ke, Qe, We, Me, je;
  const w = u === "DISTRIBUTOR_OWNER" || u === "DISTRIBUTOR_EMPLOYEE", T = w ? "Проверьте заказ и причину отказа или конфликта в 1С." : "Обратитесь к менеджеру дистрибьютора.", s = mr(), [c] = h(() => {
    const r = s.getQueryData(Pe);
    return (r == null ? void 0 : r.identity) === i ? r : void 0;
  }), [y, X] = h((c == null ? void 0 : c.draft) ?? ""), [S, K] = h((c == null ? void 0 : c.search) ?? ""), [g, C] = h((c == null ? void 0 : c.page) ?? 0), [P, x] = h((c == null ? void 0 : c.originFilter) ?? ""), [H, U] = h((c == null ? void 0 : c.pendingFilter) ?? ""), [b, B] = h((c == null ? void 0 : c.dateFrom) ?? ""), [O, Y] = h((c == null ? void 0 : c.dateTo) ?? ""), [Z, oe] = h(""), [o, Q] = h((c == null ? void 0 : c.filters) ?? {}), [ee, pe] = h(!1), ce = I(null);
  M(() => {
    var r;
    Z && ee && ((r = ce.current) == null || r.focus());
  }, [Z, ee]), M(() => {
    const r = s.getQueryData(Pe);
    r && r.identity !== i && s.removeQueries({ queryKey: Pe }), l === void 0 && s.setQueryData(
      Pe,
      { identity: i, draft: y, search: S, page: g, originFilter: P, pendingFilter: H, dateFrom: b, dateTo: O, filters: o }
    );
  }, [s, i, l, y, S, g, P, H, b, O, o]);
  const se = !!(S || Object.keys(o).length), Ce = [
    ...S ? [`Номер: ${S}`] : [],
    ...o.origin ? [{
      PORTAL: "Созданы на портале",
      SOURCE: "Созданы в 1С",
      UNKNOWN: "Происхождение не определено"
    }[o.origin]] : [],
    ...o.pending === void 0 ? [] : [o.pending ? "Есть неопределённые связи" : "Связи определены"],
    ...o.dateFrom || o.dateTo ? [`Период: ${o.dateFrom ? rr(o.dateFrom) : "без даты начала"} — ${o.dateTo ? rr(o.dateTo, !0) : "без даты окончания"}`] : []
  ], [de, ne] = h(null), [ve, ye] = h(!1), [Ne, be] = h(!1), re = I({ token: a, generation: 0 });
  re.current.token !== a && (re.current = { token: a, generation: re.current.generation + 1 });
  const [me, ue] = h(null), d = I(null), m = I(!0), N = I(/* @__PURE__ */ new Set());
  M(() => {
    m.current = !0;
    const r = N.current;
    return () => {
      var v;
      m.current = !1, re.current.generation += 1, (v = d.current) == null || v.abort(), r.forEach((_) => URL.revokeObjectURL(_));
    };
  }, []);
  const F = l === void 0 || Number.isSafeInteger(l) && l > 0, f = le({
    queryKey: ["portal-orders", i, S, g, o],
    queryFn: ({ signal: r }) => Er(t, a, { search: S, page: g, ...o }, r),
    enabled: l === void 0,
    retry: !1,
    staleTime: 0,
    refetchInterval: 3e4
  }), R = le({
    queryKey: ["portal-order", i, l],
    queryFn: ({ signal: r }) => wr(t, a, l, r),
    enabled: l !== void 0 && F,
    retry: !1,
    staleTime: 0,
    refetchInterval: 3e4
  }), ae = l === void 0 ? f : R, $ = le({
    queryKey: ["portal-order-operations", i, l],
    queryFn: ({ signal: r }) => Ve(t, a, l, r),
    enabled: l !== void 0 && F && !!R.data && !R.isError,
    retry: !1,
    staleTime: 0,
    refetchInterval: 3e4,
    gcTime: 0
  });
  M(() => () => {
    s.removeQueries({ queryKey: ["portal-order-operations", i, l], exact: !0 });
  }, [s, i, l]);
  const q = le({
    queryKey: ["portal-order-command", i, l],
    queryFn: ({ signal: r }) => He(t, a, l, r),
    enabled: l !== void 0 && F && !!R.data && !R.isError,
    retry: !1,
    staleTime: 0,
    refetchInterval: 3e4
  }), W = (ke = R.data) == null ? void 0 : ke.sourceConfirmation, he = W ? JSON.stringify([
    (qe = R.data) == null ? void 0 : qe.order.externalId,
    W.connectionId,
    W.generation,
    W.revision,
    W.snapshotId
  ]) : null, J = le({
    queryKey: [
      "portal-order-source-assets",
      i,
      l,
      he
    ],
    queryFn: ({ signal: r }) => Ge(t, a, l, r),
    enabled: l !== void 0 && F && !R.isError && ((xe = R.data) == null ? void 0 : xe.attachmentsAllowed) === !0,
    retry: !1,
    staleTime: 0,
    refetchInterval: 3e4
  }), Fe = de instanceof V && [401, 403, 404].includes(de.status), lr = ((Ue = R.data) == null ? void 0 : Ue.attachmentsAllowed) === !0 && J.error instanceof V && [401, 403, 404].includes(J.error.status), or = q.error instanceof V && [401, 403, 404].includes(q.error.status), _e = $.error instanceof V && [401, 403, 404].includes($.error.status), Re = ae.isError || Fe || lr || or || _e || ve, Te = W ? (J.data ?? []).filter((r) => {
    var v;
    return r.connectionId === W.connectionId && r.generation === W.generation && r.revision === W.revision && r.sourceOrderId === ((v = R.data) == null ? void 0 : v.order.externalId);
  }) : [], Oe = !!((Be = J.data) != null && Be.length && Te.length !== J.data.length), Se = I(!1);
  Se.current = !Re && !J.isError && !Oe && he !== null && (($e = R.data) == null ? void 0 : $e.attachmentsAllowed) === !0;
  const Ie = I(he);
  Ie.current = he, M(() => () => {
    var r;
    (r = d.current) == null || r.abort(), N.current.forEach((v) => URL.revokeObjectURL(v)), N.current.clear();
  }, [he]), M(() => {
    var r, v;
    (Re || Oe || ((r = R.data) == null ? void 0 : r.attachmentsAllowed) === !1) && ((v = d.current) == null || v.abort(), N.current.forEach((_) => URL.revokeObjectURL(_)), N.current.clear(), ue(null));
  }, [Re, Oe, (Ke = R.data) == null ? void 0 : Ke.attachmentsAllowed]), M(() => {
    ue(null);
  }, [he]);
  async function cr(r, v) {
    if (l === void 0 || me !== null || !Se.current || !Te.some((ie) => ie.id === r)) return;
    const _ = he, G = new AbortController();
    d.current = G, ue(r), ne(null);
    try {
      const ie = await Cr(t, a, l, r, G.signal);
      if (G.signal.aborted || !Se.current || Ie.current !== _) return;
      const z = URL.createObjectURL(ie);
      N.current.add(z);
      const Ee = document.createElement("a");
      Ee.href = z, Ee.download = v ?? `order-${l}-${r}`, document.body.append(Ee), Ee.click(), Ee.remove(), window.setTimeout(() => {
        URL.revokeObjectURL(z), N.current.delete(z);
      }, 1e3);
    } catch (ie) {
      G.signal.aborted || ne(ie);
    } finally {
      G.signal.aborted || ue(null);
    }
  }
  async function sr() {
    if (l === void 0 || Ne) return;
    const r = ++re.current.generation, v = () => m.current && re.current.generation === r;
    be(!0);
    try {
      const _ = await R.refetch();
      if (!v() || _.isError || !_.data) return;
      const G = _.data.sourceConfirmation, ie = G ? JSON.stringify([
        _.data.order.externalId,
        G.connectionId,
        G.generation,
        G.revision,
        G.snapshotId
      ]) : null;
      if (await Promise.all([
        s.cancelQueries({ queryKey: ["portal-order-command", i, l], exact: !0 }),
        s.cancelQueries({ queryKey: ["portal-order-operations", i, l], exact: !0 }),
        s.cancelQueries({ queryKey: ["portal-order-source-assets", i, l, ie], exact: !0 })
      ]), !v()) return;
      await Promise.all([
        ...ve ? [nr(t, a, l)] : [],
        s.fetchQuery({
          queryKey: ["portal-order-command", i, l],
          queryFn: ({ signal: z }) => He(t, a, l, z),
          staleTime: 0,
          retry: !1
        }),
        s.fetchQuery({
          queryKey: ["portal-order-operations", i, l],
          queryFn: ({ signal: z }) => Ve(t, a, l, z),
          staleTime: 0,
          retry: !1
        }),
        ..._.data.attachmentsAllowed ? [s.fetchQuery({
          queryKey: ["portal-order-source-assets", i, l, ie],
          queryFn: ({ signal: z }) => Ge(t, a, l, z),
          staleTime: 0,
          retry: !1
        })] : []
      ]), v() && s.getQueryData(["portal-order", i, l]) === _.data && (ne(null), ye(!1));
    } catch {
    } finally {
      m.current && be(!1);
    }
  }
  if (!F) return /* @__PURE__ */ e(fe, { variant: "danger", body: "Некорректный номер ссылки на заказ." });
  if (Re) return /* @__PURE__ */ n("section", { className: "portal-orders", children: [
    /* @__PURE__ */ e("h1", { children: "Заказы" }),
    /* @__PURE__ */ e(fe, { variant: "danger", body: ae.error instanceof V && ae.error.status === 404 ? "Заказ не найден или больше не входит в вашу область доступа." : "Не удалось подтвердить текущий доступ или получить свежие данные. Прежние данные скрыты." }),
    /* @__PURE__ */ e(E, { disabled: Ne, onClick: () => {
      var r;
      if (Fe || ve) {
        sr();
        return;
      }
      ae.refetch(), (r = R.data) != null && r.attachmentsAllowed && J.refetch(), l !== void 0 && q.refetch(), l !== void 0 && $.refetch();
    }, children: "Проверить снова" }),
    l !== void 0 && /* @__PURE__ */ e(E, { onClick: k, children: "К списку заказов" })
  ] });
  if (ae.isPending && l !== void 0) return /* @__PURE__ */ e("p", { role: "status", children: "Загружаем текущие заказы…" });
  if (l === void 0) return /* @__PURE__ */ n("section", { className: "portal-orders", children: [
    /* @__PURE__ */ n("header", { children: [
      /* @__PURE__ */ e("p", { className: "portal-orders-eyebrow", children: "Ежедневная работа" }),
      /* @__PURE__ */ e("h1", { children: "Заказы" }),
      /* @__PURE__ */ e("p", { children: "Только заказы в вашей текущей области доступа. Статусы и обработка — на стороне 1С." })
    ] }),
    /* @__PURE__ */ n("form", { className: "portal-orders-search", onSubmit: (r) => {
      var v;
      if (r.preventDefault(), b && O && b > O) {
        pe(!0), oe("Дата начала не может быть позже даты окончания."), ee && ((v = ce.current) == null || v.focus());
        return;
      }
      oe(""), K(y.trim()), C(0), Q({
        ...P ? { origin: P } : {},
        ...H ? { pending: H === "true" } : {},
        ...b ? { dateFrom: er(b) } : {},
        ...O ? { dateTo: er(O, !0) } : {}
      });
    }, children: [
      /* @__PURE__ */ n("div", { className: "portal-orders-search-row", children: [
        /* @__PURE__ */ n("label", { htmlFor: "portal-order-search", children: [
          "Номер заказа",
          /* @__PURE__ */ e(
            Pr,
            {
              id: "portal-order-search",
              name: "orderNumber",
              placeholder: "Например, DS2B-123",
              maxLength: 160,
              value: y,
              onChange: (r) => X(r.target.value)
            }
          )
        ] }),
        /* @__PURE__ */ e(E, { type: "submit", variant: "primary", children: "Найти" })
      ] }),
      /* @__PURE__ */ n(
        "details",
        {
          className: "portal-orders-filters",
          open: ee,
          onToggle: (r) => pe(r.currentTarget.open),
          children: [
            /* @__PURE__ */ e("summary", { children: "Фильтры: источник, связи и период" }),
            /* @__PURE__ */ n("div", { className: "portal-orders-filter-fields", children: [
              /* @__PURE__ */ n("label", { children: [
                "Происхождение",
                /* @__PURE__ */ n("select", { value: P, onChange: (r) => x(r.target.value), children: [
                  /* @__PURE__ */ e("option", { value: "", children: "Все заказы" }),
                  /* @__PURE__ */ e("option", { value: "PORTAL", children: "Созданы на портале" }),
                  /* @__PURE__ */ e("option", { value: "SOURCE", children: "Созданы в 1С" }),
                  /* @__PURE__ */ e("option", { value: "UNKNOWN", children: "Происхождение не определено" })
                ] })
              ] }),
              /* @__PURE__ */ n("label", { children: [
                "Связи заказа",
                /* @__PURE__ */ n("select", { value: H, onChange: (r) => U(r.target.value), children: [
                  /* @__PURE__ */ e("option", { value: "", children: "Все" }),
                  /* @__PURE__ */ e("option", { value: "true", children: "Есть неопределённые связи" }),
                  /* @__PURE__ */ e("option", { value: "false", children: "Связи определены" })
                ] })
              ] }),
              /* @__PURE__ */ n("label", { children: [
                "Дата заказа с",
                /* @__PURE__ */ e("input", { type: "date", value: b, onChange: (r) => B(r.target.value) })
              ] }),
              /* @__PURE__ */ n("label", { children: [
                "Дата заказа по",
                /* @__PURE__ */ e(
                  "input",
                  {
                    ref: ce,
                    type: "date",
                    value: O,
                    "aria-invalid": !!Z,
                    "aria-describedby": Z ? "order-filter-error" : void 0,
                    onChange: (r) => {
                      Y(r.target.value), oe("");
                    }
                  }
                )
              ] })
            ] }),
            Z && /* @__PURE__ */ e("p", { id: "order-filter-error", role: "alert", children: Z }),
            /* @__PURE__ */ e("p", { className: "portal-orders-filter-hint", children: "Период включает обе даты в часовом поясе вашего устройства. Если дата документа не передана, используется дата появления заказа на портале. Неопределённые связи — не статус обработки в 1С." }),
            /* @__PURE__ */ e(E, { type: "submit", children: "Применить фильтры" })
          ]
        }
      ),
      (se || y || P || H || b || O) && /* @__PURE__ */ n("div", { className: "portal-orders-applied", children: [
        se && /* @__PURE__ */ n("p", { role: "status", children: [
          "Применено: ",
          Ce.join(" · ")
        ] }),
        /* @__PURE__ */ e(E, { onClick: () => {
          X(""), K(""), C(0), Q({}), x(""), U(""), B(""), Y(""), oe("");
        }, children: "Сбросить" })
      ] })
    ] }),
    /* @__PURE__ */ n("div", { className: "portal-orders-toolbar", children: [
      /* @__PURE__ */ n("span", { children: [
        "Найдено: ",
        ((Qe = f.data) == null ? void 0 : Qe.totalElements) ?? "…"
      ] }),
      /* @__PURE__ */ e(E, { loading: f.isFetching, onClick: () => void f.refetch(), children: "Обновить" })
    ] }),
    f.isPending ? /* @__PURE__ */ e("p", { role: "status", children: "Загружаем текущие заказы…" }) : f.data.content.length ? /* @__PURE__ */ e("ul", { className: "portal-order-cards", children: f.data.content.map((r) => /* @__PURE__ */ e("li", { children: /* @__PURE__ */ n(te, { padding: "lg", children: [
      /* @__PURE__ */ n("div", { className: "portal-order-card-top", children: [
        /* @__PURE__ */ n("div", { children: [
          /* @__PURE__ */ e("h2", { children: r.documentNumber ?? `Заказ №${r.id}` }),
          /* @__PURE__ */ n("p", { children: [
            ge(r.documentDate ?? r.createdAt),
            " · ",
            Xe(r)
          ] })
        ] }),
        /* @__PURE__ */ e("strong", { children: we(r.totalAmount, r.currency) })
      ] }),
      /* @__PURE__ */ e("p", { className: "portal-order-status", children: Ze(r) }),
      /* @__PURE__ */ e("p", { children: r.currentTradepointName ?? `Точка №${r.tradepointId ?? "не определена"}` }),
      /* @__PURE__ */ e("p", { children: r.deliveryAddress ?? "Адрес доставки в заказе не указан" }),
      /* @__PURE__ */ n("p", { children: [
        "Плательщик: ",
        r.currentPayerName ?? "Не определён"
      ] }),
      /* @__PURE__ */ n(E, { onClick: () => A(r.id), children: [
        "Открыть заказ ",
        r.documentNumber ?? r.id
      ] })
    ] }) }, r.id)) }) : /* @__PURE__ */ n(te, { padding: "lg", children: [
      /* @__PURE__ */ e("h2", { children: se ? "Ничего не найдено" : "Пока нет доступных заказов" }),
      /* @__PURE__ */ e("p", { children: se ? "Измените условия или сбросьте фильтры." : "Здесь появятся созданные заказы. История из 1С доступна клиентам только если её включил дистрибьютор и настроены точные связи точки и плательщика." })
    ] }),
    f.data && /* @__PURE__ */ n("nav", { className: "portal-orders-toolbar", "aria-label": "Страницы заказов", children: [
      /* @__PURE__ */ e(E, { disabled: g === 0, onClick: () => C(g - 1), children: "Предыдущая" }),
      /* @__PURE__ */ n("span", { children: [
        "Страница ",
        g + 1,
        " из ",
        Math.max(1, f.data.totalPages)
      ] }),
      /* @__PURE__ */ e(E, { disabled: g + 1 >= f.data.totalPages, onClick: () => C(g + 1), children: "Следующая" })
    ] })
  ] });
  const L = R.data, D = L.order, p = (We = q.data) == null ? void 0 : We.command, De = !!(p != null && p.outcome && p.receivedAt), Le = De && (p == null ? void 0 : p.outcome) === "APPLIED" && W && W.connectionId === p.connectionId && W.generation === p.generation && D.externalId === p.sourceOrderId && p.resultRevision !== null && BigInt(W.revision) >= BigInt(p.resultRevision), dr = async () => {
    var v;
    const r = await R.refetch();
    r.isError || !m.current || await Promise.all([
      q.refetch(),
      $.refetch(),
      ...(v = r.data) != null && v.attachmentsAllowed ? [J.refetch()] : []
    ]);
  };
  return /* @__PURE__ */ n("section", { className: "portal-orders", children: [
    /* @__PURE__ */ e(E, { onClick: k, children: "← К заказам" }),
    /* @__PURE__ */ n("header", { children: [
      /* @__PURE__ */ e("p", { className: "portal-orders-eyebrow", children: Xe(D) }),
      /* @__PURE__ */ e("h1", { children: D.documentNumber ?? `Заказ №${D.id}` }),
      /* @__PURE__ */ n("p", { children: [
        ge(D.documentDate ?? D.createdAt),
        " · ",
        Ze(D)
      ] }),
      /* @__PURE__ */ n("strong", { children: [
        "Итого: ",
        we(D.totalAmount, D.currency)
      ] })
    ] }),
    /* @__PURE__ */ n("section", { "aria-label": "Состояние заказа", children: [
      q.isError ? /* @__PURE__ */ e("p", { role: "alert", children: "Не удалось обновить состояние обработки. Повторите обновление данных." }) : De && (p == null ? void 0 : p.outcome) !== "APPLIED" ? /* @__PURE__ */ e(
        fe,
        {
          variant: "warning",
          body: `${(p == null ? void 0 : p.outcome) === "REJECTED" ? "Запрос отклонён." : w ? "Возник конфликт запроса." : "Требуется проверка менеджера: возник конфликт запроса."} ${T} Автоматическая повторная отправка не выполняется.`
        }
      ) : De && (p == null ? void 0 : p.outcome) === "APPLIED" && !Le ? /* @__PURE__ */ e("p", { role: "status", children: "Обработка завершена. Ожидаем обновлённые данные заказа." }) : !L.sourceConfirmation && /* @__PURE__ */ e("p", { role: "status", children: D.origin === "PORTAL" ? "Заказ сохранён. Ожидаем подтверждение дистрибьютора." : "Исторический заказ. Актуальное состояние пока не подтверждено." }),
      /* @__PURE__ */ e(
        E,
        {
          loading: R.isFetching || q.isFetching || $.isFetching || J.isFetching,
          onClick: () => void dr(),
          children: "Обновить данные"
        }
      )
    ] }),
    /* @__PURE__ */ e(
      Lr,
      {
        api: t,
        token: a,
        identity: i,
        orderId: D.id,
        onAccessDenied: () => ye(!0),
        onSourceApplied: () => {
          R.refetch();
        }
      }
    ),
    D.pending && /* @__PURE__ */ e(fe, { variant: "warning", body: "Не все источниковые связи заказа определены. Менеджеру нужно проверить данные обмена." }),
    $.isError && !_e && /* @__PURE__ */ e("p", { role: "alert", children: "Не удалось проверить ограничения. Изменение состава заказа на портале недоступно." }),
    /* @__PURE__ */ n(te, { padding: "lg", children: [
      /* @__PURE__ */ e("h2", { children: "Состав заказа" }),
      L.lines.length ? /* @__PURE__ */ e("ol", { className: "portal-order-lines", children: L.lines.map((r) => {
        var v;
        return /* @__PURE__ */ n("li", { children: [
          /* @__PURE__ */ n("div", { children: [
            /* @__PURE__ */ e("strong", { children: r.name ?? `Товар 1С ${r.skuExternalId}` }),
            /* @__PURE__ */ n("p", { children: [
              "Артикул: ",
              r.article ?? "не указан"
            ] })
          ] }),
          /* @__PURE__ */ n("div", { children: [
            "Количество: ",
            ir(r.quantity),
            /* @__PURE__ */ e("p", { children: (v = r.unitName) != null && v.trim() ? r.unitName : /* @__PURE__ */ n(j, { children: [
              "Название единицы в заказе не указано",
              r.unitCode ? ` · код ${r.unitCode}` : ""
            ] }) }),
            /* @__PURE__ */ n("p", { children: [
              "По ",
              we(r.price, D.currency)
            ] })
          ] }),
          /* @__PURE__ */ e("strong", { children: we(r.lineTotal, D.currency) })
        ] }, r.id);
      }) }) : /* @__PURE__ */ e("p", { children: "Строки ещё не получены." }),
      /* @__PURE__ */ n("p", { className: "portal-order-total", children: [
        "Итого по заказу: ",
        /* @__PURE__ */ e("strong", { children: we(D.totalAmount, D.currency) })
      ] })
    ] }),
    /* @__PURE__ */ n(te, { padding: "lg", children: [
      /* @__PURE__ */ e("h2", { children: "Доставка и плательщик" }),
      /* @__PURE__ */ n("dl", { children: [
        /* @__PURE__ */ e("dt", { children: "Торговая точка · текущее название" }),
        /* @__PURE__ */ e("dd", { children: D.currentTradepointName ?? "Не определена" }),
        /* @__PURE__ */ e("dt", { children: "Адрес в заказе" }),
        /* @__PURE__ */ e("dd", { children: D.deliveryAddress ?? "Не указан" }),
        /* @__PURE__ */ e("dt", { children: "Дата доставки" }),
        /* @__PURE__ */ e("dd", { children: D.deliveryDate ?? "Не указана" }),
        /* @__PURE__ */ e("dt", { children: "Плательщик · текущее название" }),
        /* @__PURE__ */ e("dd", { children: D.currentPayerName ?? "Не определён" }),
        /* @__PURE__ */ e("dt", { children: "Комментарий к заказу" }),
        /* @__PURE__ */ e("dd", { children: D.comment ?? "Нет комментария" })
      ] }),
      /* @__PURE__ */ e("p", { children: w ? "Необходимость изменения состава заказа проверьте в 1С." : "Для изменения состава заказа обратитесь к менеджеру дистрибьютора." })
    ] }),
    /* @__PURE__ */ n("details", { children: [
      /* @__PURE__ */ e("summary", { children: "Подробности обработки" }),
      !L.sourceConfirmation && /* @__PURE__ */ e("p", { children: "Подтверждённый снимок 1С ещё не получен. Данные заказа на портале — это не подтверждение отгрузки или резерва." }),
      /* @__PURE__ */ n(te, { padding: "lg", children: [
        /* @__PURE__ */ e("h2", { children: "Результат отправки в 1С" }),
        !q.isPending && !q.isError && p && /* @__PURE__ */ n("p", { children: [
          "Очередь: ",
          qr(p.state),
          " Состояние выдачи не подтверждает применение заказа в 1С."
        ] }),
        q.isPending ? /* @__PURE__ */ e("p", { role: "status", children: "Проверяем результат команды…" }) : q.isError ? /* @__PURE__ */ e("p", { role: "alert", children: "Не удалось получить свежий результат команды. Прежний результат скрыт." }) : p ? De ? /* @__PURE__ */ n(j, { children: [
          /* @__PURE__ */ e("p", { children: p.outcome === "APPLIED" ? "1С сообщила: команда применена." : p.outcome === "REJECTED" ? "1С отклонила команду." : "1С сообщила о конфликте команды." }),
          /* @__PURE__ */ n("p", { children: [
            "Результат получен: ",
            ge(p.receivedAt)
          ] }),
          p.errorCode && /* @__PURE__ */ n("p", { children: [
            "Код результата: ",
            p.errorCode
          ] }),
          p.outcome === "APPLIED" && /* @__PURE__ */ e("p", { children: Le ? "Подтверждённый снимок этой или более новой ревизии получен." : "Ожидается подтверждённый снимок 1С для результата команды. Данные заказа пока не подтверждают этот результат." }),
          p.outcome !== "APPLIED" && /* @__PURE__ */ n("p", { children: [
            T,
            " Автоматическая повторная отправка не выполняется."
          ] }),
          /* @__PURE__ */ e("p", { children: "Результат команды, снимок заказа и PDF проверяются отдельно; применение команды не означает отгрузку." })
        ] }) : /* @__PURE__ */ e("p", { children: "Подтверждённый результат команды по новому протоколу ещё не получен. Техническое состояние отправки не доказывает принятие заказа в 1С." }) : /* @__PURE__ */ e("p", { children: "Для заказа нет команд портала." })
      ] }),
      /* @__PURE__ */ n(te, { padding: "lg", children: [
        /* @__PURE__ */ e("h2", { children: "Обработка в 1С" }),
        /* @__PURE__ */ n("dl", { children: [
          /* @__PURE__ */ e("dt", { children: "Последнее получение данных" }),
          /* @__PURE__ */ e("dd", { children: L.sourceConfirmation ? ge(L.sourceConfirmation.receivedAt) : "Подтверждённый снимок ещё не получен" }),
          /* @__PURE__ */ e("dt", { children: "Ревизия источника" }),
          /* @__PURE__ */ e("dd", { children: ((Me = L.sourceConfirmation) == null ? void 0 : Me.revision) ?? "Не подтверждена" }),
          L.sourceConfirmation && /* @__PURE__ */ n(j, { children: [
            /* @__PURE__ */ e("dt", { children: "Поколение источника" }),
            /* @__PURE__ */ e("dd", { children: L.sourceConfirmation.generation }),
            /* @__PURE__ */ e("dt", { children: "Изменено в учётной системе" }),
            /* @__PURE__ */ e("dd", { children: L.sourceConfirmation.sourceModifiedAt ? ge(L.sourceConfirmation.sourceModifiedAt) : "Время не передано" })
          ] })
        ] }),
        L.sourceConfirmation && /* @__PURE__ */ e("p", { children: "Показан подтверждённый снимок из учётной системы. Он не означает отгрузку или резерв, если это не указано в статусе заказа." }),
        /* @__PURE__ */ e("h3", { children: "Изменение заказа" }),
        $.isFetching || $.isPending ? /* @__PURE__ */ e("p", { role: "status", children: "Проверяем доступность операций…" }) : $.isError ? null : $.data && /* @__PURE__ */ n(j, { children: [
          /* @__PURE__ */ e("p", { children: "Изменение состава заказа на портале пока недоступно: правила обработки в 1С ещё не подтверждены." }),
          /* @__PURE__ */ n("details", { children: [
            /* @__PURE__ */ e("summary", { children: "Дополнительные ограничения для этого заказа" }),
            ["edit"].map((r) => {
              const v = $.data[r].reasons.filter((_) => _ !== "source_window_unverified" && _ !== "operation_adapter_not_verified");
              return v.length > 0 && /* @__PURE__ */ n("p", { children: [
                /* @__PURE__ */ e("strong", { children: "Изменение:" }),
                " ",
                v.map((_) => xr[_]).join("; "),
                "."
              ] }, r);
            }),
            /* @__PURE__ */ e("p", { children: "Настройки портала сами по себе не включают обработку в 1С." })
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ n("div", { className: "portal-order-detail-grid", children: [
      /* @__PURE__ */ n(te, { padding: "lg", children: [
        /* @__PURE__ */ e("h2", { children: "Документы" }),
        L.attachmentsAllowed ? J.isPending ? /* @__PURE__ */ e("p", { role: "status", children: "Проверяем текущие PDF…" }) : J.isError ? /* @__PURE__ */ e("p", { role: "alert", children: "Не удалось проверить текущие PDF. Прежний список скрыт." }) : Oe ? /* @__PURE__ */ e("p", { role: "status", children: "Данные заказа обновились. Обновите данные перед скачиванием документов." }) : (je = J.data) != null && je.length ? /* @__PURE__ */ e("ul", { children: Te.map((r) => /* @__PURE__ */ n("li", { children: [
          /* @__PURE__ */ n("details", { children: [
            /* @__PURE__ */ e("summary", { children: "Сведения о документе" }),
            /* @__PURE__ */ n("p", { children: [
              "Ревизия ",
              r.revision,
              " · шаблон ",
              r.templateId,
              ", версия ",
              r.templateVersion
            ] })
          ] }),
          /* @__PURE__ */ n(
            E,
            {
              loading: me === r.id,
              disabled: me !== null,
              onClick: () => void cr(r.id, r.fileName),
              children: [
                "Скачать ",
                r.fileName ?? "документ"
              ]
            }
          )
        ] }, r.id)) }) : /* @__PURE__ */ e("p", { children: "Документы пока не получены." }) : /* @__PURE__ */ e("p", { children: "Просмотр файлов вам не разрешён." }),
        !!de && /* @__PURE__ */ e("p", { role: "alert", children: "Файл не получен. Проверьте соединение и повторите загрузку." })
      ] }),
      /* @__PURE__ */ n("details", { children: [
        /* @__PURE__ */ e("summary", { children: "История статусов" }),
        L.statusEvents.length ? /* @__PURE__ */ e("ol", { className: "portal-order-timeline", children: L.statusEvents.map((r) => /* @__PURE__ */ n("li", { children: [
          /* @__PURE__ */ e("strong", { children: r.statusTo }),
          " · ",
          ge(r.occurredAt),
          r.comment && /* @__PURE__ */ e("p", { children: r.comment })
        ] }, r.id)) }) : /* @__PURE__ */ e("p", { children: "Изменения статуса ещё не получены." })
      ] })
    ] })
  ] });
}
function Xe(t) {
  return { PORTAL: "Создан на портале", SOURCE: "Заказ из 1С", UNKNOWN: "История · происхождение не подтверждено" }[t.origin];
}
function Ze(t) {
  var a;
  return (a = t.sourceStatusName) != null && a.trim() ? t.sourceStatusName : t.origin === "PORTAL" && t.statusCode === "new_in_portal" ? "Сохранён на портале" : `Код статуса: ${t.statusCode}`;
}
function ge(t) {
  return new Date(t).toLocaleString("ru-RU");
}
function er(t, a = !1) {
  const i = /* @__PURE__ */ new Date(`${t}T00:00:00`);
  return a && i.setDate(i.getDate() + 1), i.toISOString();
}
function rr(t, a = !1) {
  const i = new Date(t);
  return a && i.setDate(i.getDate() - 1), i.toLocaleDateString("ru-RU");
}
function Yr({ scope: t, children: a }) {
  return /* @__PURE__ */ e(Br, { children: a }, t);
}
function Br({ children: t }) {
  const [a] = h(() => new gr({ defaultOptions: {
    queries: { retry: 1, staleTime: 3e4, refetchOnWindowFocus: !1 },
    mutations: { retry: 0 }
  } })), i = I(!1);
  return M(() => (i.current = !0, () => {
    i.current = !1, queueMicrotask(() => {
      i.current || (a.cancelQueries(), a.clear());
    });
  }), [a]), /* @__PURE__ */ e(vr, { client: a, children: t });
}
const tr = [
  ["clientEditAllowed", "Клиенты могут запрашивать изменение заказа"],
  ["clientCancelAllowed", "Клиенты могут запрашивать отмену заказа"],
  ["employeeEditAllowed", "Сотрудники дистрибьютора могут запрашивать изменение заказа"],
  ["employeeCancelAllowed", "Сотрудники дистрибьютора могут запрашивать отмену заказа"]
];
function $r({ api: t, token: a, identity: i }) {
  return /* @__PURE__ */ e(Kr, { api: t, token: a, identity: i }, i);
}
function Kr({ api: t, token: a, identity: i }) {
  const u = le({
    queryKey: ["portal-order-policy", i],
    queryFn: () => ar(t, a),
    retry: !1,
    staleTime: 0
  }), [l, A] = h(null), [k, w] = h(null), [T, s] = h(!1), [c, y] = h(""), [X, S] = h(!1), [K, g] = h(!1), C = I(!0), P = I(!1);
  M(() => (C.current = !0, () => {
    C.current = !1;
  }), []);
  const x = Nr.safeParse(u.data), H = (b, B, O, Y) => {
    k === null && w(Y), A({ ...l ?? O, [b]: B }), S(!1);
  };
  async function U(b, B) {
    if (!(P.current || c || K || u.isFetching)) {
      P.current = !0, s(!0), S(!1);
      try {
        if (await Rr(t, a, k ?? b.version, B), !C.current) return;
        A(null), w(null), S(!0);
      } catch (O) {
        if (!C.current) return;
        O instanceof V && [401, 403].includes(O.status) ? (g(!0), A(null), w(null)) : y(O instanceof V && O.status === 409 ? "Политика изменена в другой сессии. Ваш выбор сохранён; сравните его с текущими значениями." : "Результат сохранения не подтверждён. Ваш выбор сохранён; проверьте текущие значения перед новой попыткой.");
      } finally {
        C.current && (await u.refetch(), C.current && s(!1)), P.current = !1;
      }
    }
  }
  return /* @__PURE__ */ e("section", { className: "portal-mutation-policy", children: /* @__PURE__ */ n(te, { padding: "lg", children: [
    /* @__PURE__ */ e("h2", { children: "Запросы изменения и отмены заказов" }),
    /* @__PURE__ */ e("p", { children: "Выберите, кому разрешено обращаться с такими запросами. По умолчанию все разрешения выключены." }),
    /* @__PURE__ */ e(fe, { variant: "info", body: "Разрешение не включает функцию: требуется поддержка подключённой 1С и проверка её точной сборки. Также действуют права сотрудника, доступ к заказу и его статус в 1С." }),
    K || u.isError ? /* @__PURE__ */ n(j, { children: [
      /* @__PURE__ */ e(fe, { variant: "danger", body: "Доступ или текущие настройки не подтверждены. Прежние значения скрыты." }),
      /* @__PURE__ */ e(E, { onClick: () => {
        u.refetch().then((b) => {
          C.current && !b.isError && g(!1);
        });
      }, children: "Проверить доступ и настройки" })
    ] }) : u.isPending ? /* @__PURE__ */ e("p", { role: "status", children: "Проверяем политику заказов…" }) : x.success ? /* @__PURE__ */ n(j, { children: [
      c && /* @__PURE__ */ e("p", { role: "alert", children: c }),
      X && /* @__PURE__ */ e("p", { role: "status", children: "Разрешения сохранены. Это не подтверждение готовности изменения и отмены заказов в 1С." }),
      c && /* @__PURE__ */ n(j, { children: [
        /* @__PURE__ */ e("ul", { "aria-label": "Сохранённые разрешения", children: tr.map(([b, B]) => /* @__PURE__ */ n("li", { children: [
          B,
          ": ",
          x.data[b] ? "разрешено владельцем" : "запрещено владельцем"
        ] }, b)) }),
        /* @__PURE__ */ e(E, { disabled: T || u.isFetching, onClick: () => {
          w(u.data.version), y("");
        }, children: "Сверил значения — оставить мой выбор" }),
        /* @__PURE__ */ e(E, { disabled: T || u.isFetching, onClick: () => {
          A(null), w(null), y("");
        }, children: "Загрузить сохранённые значения" })
      ] }),
      /* @__PURE__ */ n("form", { onSubmit: (b) => {
        b.preventDefault(), !T && !c && U(u.data, l ?? x.data);
      }, children: [
        /* @__PURE__ */ n("fieldset", { disabled: T || !!c || u.isFetching, children: [
          /* @__PURE__ */ e("legend", { children: "Разрешения владельца" }),
          tr.map(([b, B]) => /* @__PURE__ */ n("label", { className: "portal-order-policy-choice", children: [
            /* @__PURE__ */ e(
              "input",
              {
                type: "checkbox",
                name: b,
                checked: (l ?? x.data)[b],
                onChange: (O) => H(b, O.target.checked, x.data, u.data.version)
              }
            ),
            B
          ] }, b))
        ] }),
        /* @__PURE__ */ e(E, { type: "submit", variant: "primary", loading: T, disabled: !!c || u.isFetching, children: "Сохранить разрешения" })
      ] })
    ] }) : /* @__PURE__ */ e("p", { role: "status", children: "Эта версия сервера не предоставляет настройку запросов изменения и отмены. Разрешения недоступны." })
  ] }) });
}
function zr({ api: t, token: a, identity: i }) {
  return /* @__PURE__ */ n("section", { className: "portal-order-policies", children: [
    /* @__PURE__ */ e(Qr, { api: t, token: a, identity: i }, i),
    /* @__PURE__ */ e($r, { api: t, token: a, identity: i })
  ] });
}
function Qr({ api: t, token: a, identity: i }) {
  const [u, l] = h(!1), [A, k] = h(null), [w, T] = h(null), [s, c] = h(null), y = le({
    queryKey: ["portal-order-policy", i],
    queryFn: () => ar(t, a),
    retry: !1,
    staleTime: 0
  }), X = async (K, g) => {
    if (!(u || (s == null ? void 0 : s.kind) === "conflict" || (s == null ? void 0 : s.kind) === "unknown")) {
      l(!0), c(null);
      try {
        await Or(t, a, { version: w ?? K.version, clientHistoryVisible: g }), c({ kind: "saved", attempted: g }), k(null), T(null);
      } catch (C) {
        c({ kind: C instanceof V && C.status === 409 ? "conflict" : "unknown", attempted: g });
      } finally {
        await y.refetch(), l(!1);
      }
    }
  }, S = s !== null && s.kind !== "saved";
  return /* @__PURE__ */ n(te, { padding: "lg", children: [
    /* @__PURE__ */ e("h2", { children: "История заказов из 1С для клиентов" }),
    /* @__PURE__ */ e("p", { children: "Разрешить клиентам видеть заказы, созданные вне портала, а также импортированную историю с неизвестным происхождением. Доступ остаётся ограничен назначенными точками и плательщиками. На просмотр менеджерами этот флаг не влияет." }),
    S && /* @__PURE__ */ n("p", { role: "alert", children: [
      s.kind === "conflict" ? "Настройка изменилась в другой сессии." : "Результат сохранения не подтверждён.",
      " ",
      "Вы предлагали: ",
      s.attempted ? "показывать историю" : "скрывать историю",
      ".",
      " ",
      "Сверьте значение с сервера перед новой попыткой."
    ] }),
    (s == null ? void 0 : s.kind) === "saved" && /* @__PURE__ */ e("p", { role: "status", children: "Настройка сохранена." }),
    y.isPending ? /* @__PURE__ */ e("p", { role: "status", children: "Проверяем настройку…" }) : y.isError ? /* @__PURE__ */ n(j, { children: [
      /* @__PURE__ */ e(fe, { variant: "danger", body: "Не удалось подтвердить доступ к настройке. Прежнее значение скрыто." }),
      /* @__PURE__ */ e(E, { onClick: () => void y.refetch(), children: "Проверить снова" })
    ] }) : /* @__PURE__ */ n(j, { children: [
      /* @__PURE__ */ n("p", { children: [
        "Сохранённое значение на сервере: ",
        /* @__PURE__ */ e("strong", { children: y.data.clientHistoryVisible ? "история видна клиентам" : "история скрыта от клиентов" }),
        "."
      ] }),
      S && /* @__PURE__ */ e(E, { disabled: u || y.isFetching, onClick: () => {
        T(y.data.version), c(null);
      }, children: "Проверил значение с сервера" }),
      A !== null && /* @__PURE__ */ e(E, { disabled: u || y.isFetching, onClick: () => {
        k(null), T(null), c(null);
      }, children: "Отменить мой выбор истории" }),
      /* @__PURE__ */ e(
        Wr,
        {
          visible: A ?? y.data.clientHistoryVisible,
          onChange: (K) => {
            w === null && T(y.data.version), k(K), c(null);
          },
          pending: u,
          disabled: S || y.isFetching,
          onSave: (K) => void X(y.data, K)
        }
      )
    ] })
  ] });
}
function Wr({ visible: t, onChange: a, pending: i, disabled: u, onSave: l }) {
  return /* @__PURE__ */ n("form", { onSubmit: (A) => {
    A.preventDefault(), !i && !u && l(t);
  }, children: [
    /* @__PURE__ */ n("label", { className: "portal-order-policy-choice", children: [
      /* @__PURE__ */ e(
        "input",
        {
          type: "checkbox",
          name: "clientHistoryVisible",
          checked: t,
          disabled: i || u,
          onChange: (A) => a(A.target.checked)
        }
      ),
      "Клиенты могут видеть историю заказов из 1С"
    ] }),
    /* @__PURE__ */ e(E, { type: "submit", variant: "primary", loading: i, disabled: u, children: "Сохранить настройку истории" })
  ] });
}
export {
  zr as OrderHistoryPolicy,
  Gr as PortalOrdersWorkspace,
  Yr as PrivateQueryWorkspace,
  ir as formatExactDecimal,
  we as formatExactMoney
};
//# sourceMappingURL=index.js.map
